<script>
import { Doughnut } from 'vue-chartjs';

export default {
  name: 'Chart',
  extends: Doughnut,
  mounted() {
    this.fillData();
    this.renderChart(this.datacollection, this.options);
  },
  props: ['totalFolders', 'totalFiles'],
  data() {
    return {
      datacollection: null,
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        },
        animation: {
          duration: 0
        },
      },
    };
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: ['Archivos', 'Carpetas'],
        datasets: [
          {
            backgroundColor: [
              '#28C76F',
              '#ff9f43'
            ],
            data: [this.totalFiles, this.totalFolders]
          }
        ]
      };
    },
  }
};
</script>
